import React from 'react';

export default function RolesTable() {
    return (
        <div className="p-6 bg-gray-50 min-h-screen" style={{ overflowX: 'hidden' }}>
            <h2 className="text-xl font-semibold mb-4">Gestión de Roles</h2>
            <p className="text-gray-500">Módulo de gestión de roles y permisos en construcción.</p>
            {/* Aquí iría la tabla de roles similar a la de usuarios */}
        </div>
    );
}
